export const infoEnum = 0;
export const warningEnum = 1;
export const errorEnum = 2;

export const noProperty = "np";

export function getInfos(validationSummary, properties) {
    return getSummaryMessage(validationSummary, properties, infoEnum);
}

export function getWarnings(validationSummary, properties) {
    return getSummaryMessage(validationSummary, properties, warningEnum);
}

export function getErrors(validationSummary, properties) {
    return getSummaryMessage(validationSummary, properties, errorEnum);
}

function getSummaryMessage(validationSummary, properties, type) {
    const warnings = [];

    if (validationSummary && !validationSummary.isValid) {
        if (validationSummary.messages) {
            validationSummary.messages.forEach(message => {
                if (message.relatedProperties && message.type === type) {
                    message.relatedProperties.forEach(relatedProperty => {

                        if (properties) {
                            if (Array.isArray(properties)) {
                                properties.forEach(property => {
                                    if (property && (property.id === relatedProperty)) {
                                        warnings.push(message);
                                    }
                                });
                            } else {
                                Object.values(properties).forEach(property => {
                                    if (property.id === relatedProperty) {
                                        warnings.push(message);
                                    }
                                });
                            }
                        } else if (properties === null) {
                            warnings.push(message);
                        }
                    });
                }
            });
        }
    }

    return warnings;
}

export function getIssuesComponent(errors, warnings) {

    // Errors hide warnings: a property that is invalid should not also nag about
    // something milder at the same time.
    const issues = errors.length > 0 ? errors : warnings;

    if (issues.length === 0) {
        return null;
    }

    // One message per line. Rendering the descriptions as bare siblings glued
    // them together into a single unreadable sentence when a property had more
    // than one issue (e.g. the max-power message followed by the range message).
    return (
        <div className={errors.length > 0 ? "error-text" : "warning-text"}>
            {issues.map((issue, index) => (
                <div className="issue-message" key={`${issue.type}-${index}`}>
                    {issue.description}
                </div>
            ))}
        </div>
    );
}

export function getInfoIssues(issueByProperty, properties) {
    return getIssues(issueByProperty, properties, infoEnum);
}

export function getWarningIssues(issueByProperty, properties) {
    return getIssues(issueByProperty, properties, warningEnum);
}

export function getErrorIssues(issueByProperty, properties) {
    return getIssues(issueByProperty, properties, errorEnum);
}

export function getIssues(issueByProperty, properties, type) {

    if (issueByProperty === null
        || issueByProperty === undefined) {

        return [];
    }

    const issues = [];

    (Array.isArray(properties) ? properties : [properties]).forEach(property => {
        if (property && issueByProperty[property.id] && issueByProperty[property.id][type]) {
            issueByProperty[property.id][type].forEach(element => {
                issues.push(element);
            });
        }
    });

    return issues;
}

export function getIssuesByProperty(validationSummary, properties) {

    const issues = {};
    issues[noProperty] = {};
    issues[noProperty][warningEnum] = [];
    issues[noProperty][errorEnum] = [];

    if (validationSummary && validationSummary.messages) {
        validationSummary.messages.forEach(message => {
            if (message.relatedProperties && message.relatedProperties.length > 0) {
                message.relatedProperties.forEach(relatedProperty => {

                    if (!issues[relatedProperty]) {
                        issues[relatedProperty] = {};
                        issues[relatedProperty][warningEnum] = [];
                        issues[relatedProperty][errorEnum] = [];
                    }

                    if (!issues[relatedProperty][message.type]) {
                        issues[relatedProperty][message.type] = [];
                    }

                    issues[relatedProperty][message.type].push(message);
                });
            } else {
                if (!issues[noProperty][message.type]) {
                    issues[noProperty][message.type] = [];
                }

                issues[noProperty][message.type].push(message);
            }
        });
    }

    return issues;
}

export function isValid(validationSummary, property) {
    return getErrors(validationSummary, [property]).length <= 0;
}
